export default {
    // textarea idcard email phone
    text: [
        { _key: "eq", name: "是" },
        { _key: "ne", name: "不是" },
        { _key: "regex", name: "包含" },
        { _key: "textnot", name: "不包含" },
        { _key: "startsWith", name: "开头为" },
        { _key: "endsWith", name: "结尾为" },
        { _key: "isnull", name: "为空" },
        { _key: "notnull", name: "不为空" }
    ],
    // number date
    range: [
        { _key: "rangein", name: "在范围内（包含）" },
        { _key: "rangenin", name: "不在范围内（包含）" },
        { _key: "range", name: "在范围内" },
        { _key: "notrange", name: "不在范围内" },
        { _key: "isnull", name: "为空" },
        { _key: "notnull", name: "不为空" }
    ],
    // switch
    single: [
        { _key: "eq", name: "是" },
        { _key: "ne", name: "不是" },
        { _key: "isnull", name: "为空" },
        { _key: "notnull", name: "不为空" }
    ],
    // checkbox users departments
    multiple: [
        { _key: "in", name: "包含" },
        { _key: "nin", name: "不包含" },
        { _key: "nosize", name: "为空" },
        { _key: "size", name: "不为空" }
    ],
    // file
    has: [
        { _key: "isnull", name: "无" },
        { _key: "notnull", name: "有" }
    ],
    // region cascader
    cascader: [
        { _key: "belong", name: "属于" },
        { _key: "nbelong", name: "不属于" },
        { _key: "eq", name: "是" },
        { _key: "ne", name: "不是" },
        { _key: "nosize", name: "为空" },
        { _key: "size", name: "不为空" }
    ],
    reference: [
        { _key: "eq", name: "是" },
        { _key: "ne", name: "不是" },
        { _key: "isnull", name: "为空" },
        { _key: "notnull", name: "不为空" },
        { _key: "subSearch", name: "筛选子集" }
    ],
    referenceSet: [
        { _key: "isnull", name: "为空" },
        { _key: "notnull", name: "不为空" },
        { _key: "subSearch", name: "筛选子集" }
    ],
    flatTable: [
        { _key: "subSearch", name: "筛选子集" }
    ]
};



// WEBPACK FOOTER //
// ./src/data/mod/modFieldOperatorMap.js